import React from "react";
import Modal from 'react-bootstrap/Modal'
import DwNewShot from"../components/DwNewShot"

const DwNewShotModal = (props) => {
  return (
    <Modal show={props.show} onHide={() =>{ props.setcurrentselection(""); props.onHide();}}
      dialogClassName="dw-modal-90w"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      
      <Modal.Body>
        <DwNewShot props={props} setnewshot={props.setnewshot}/>
      </Modal.Body>
      {/* <Modal.Footer>
      <ButtonPrimary label="Close" action={props.onHide}/>
      </Modal.Footer> */}
    </Modal>
  );
}

DwNewShotModal.defaultProps = {
  show: false,
  onHide: null
}

export {DwNewShotModal}